// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guest-invoices-setup-second-card__timepicker[data-v-f6d4b400]{min-width:12rem}", ""]);
// Exports
module.exports = exports;
